// Mixins
import Delayable from "@mixins/delayable";
import Toggleable from "@mixins/toggleable";

// Utilities
import mixins from "@utils/mixins";
import { consoleWarn } from "@utils/console";

export default mixins(Delayable, Toggleable).extend({
  name: "AppHover",

  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    value: {
      type: Boolean,
      default: undefined
    }
  },

  methods: {
    onMouseEnter() {
      this.runDelay("open");
    },
    onMouseLeave() {
      this.runDelay("close");
    }
  },

  render() {
    if (!this.$scopedSlots.default && this.value === undefined) {
      consoleWarn(
        "AppHover is missing a default scopedSlot or bound value",
        this
      );
      return null;
    }

    let element;

    if (this.$scopedSlots.default) {
      element = this.$scopedSlots.default({ hover: this.isActive });
    }

    if (Array.isArray(element) && element.length === 1) {
      element = element[0];
    }

    if (!element || Array.isArray(element) || !element.tag) {
      consoleWarn("AppHover should only contain a single element", this);
      return element;
    }

    if (!this.disabled) {
      element.data = element.data || {};
      this._g(element.data, {
        mouseenter: this.onMouseEnter,
        mouseleave: this.onMouseLeave
      });
    }

    return element;
  }
});
